import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function OpDep(props){
  const [consData, setConsData] = useState([]);
  useEffect(() => {
    try{
      axios.get(baseUrl+'cons-search/')
        .then(function (response) {
          setConsData(response.data);
        });
    }catch(error){
      console.log(error);
    }
  }, []);

  return (
    <section className="container mt-4">
      <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
        <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i> Make OP Appointment
      </h3>
      <div className="row nurseInpatient">
          <div className="col-md-12">
            {[...new Map(consData.map(c => [c.department, c])).values()].map(consultant => (
              <div className="btn-group mb-2" key={consultant.department}>
                <Link to={`/op-appointment/${consultant.department}`}>
                  <button type="button" className="btn btn">
                  <i className="fa fa-user-md fa-2x"></i>

                    <span style={{ fontSize: '20px' }}>
                     <br/>
                      <small>{consultant.department}</small>
                    </span>
                  </button>
                </Link>
              </div>
            ))}
          </div>
        </div>
   </section>
  )
}

export default OpDep;
